// extracted by mini-css-extract-plugin
export default {"dashboard":"news-dashboard_dashboard__Aw66k","reorder-item":"news-dashboard_reorder-item__25rFq"};